// @flow

import * as React from 'react';

import { selectCartUUID as selectCartId } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { Button } from '@gandi/ui';

import { useAppSelector } from 'src/hooks';

import styles from './PayLaterLink.scss';

export function PayLaterLink(): React.MixedElement {
  const { __ } = useTranslator();

  const cartId = useAppSelector(selectCartId);

  return (
    <Button
      kind="link"
      to={`/cart/${cartId}/generate-proforma`}
      className={styles.container}
    >
      {__('Generate a ProForma invoice and pay later.')}
    </Button>
  );
}
